import { __decorate } from "tslib";
import fetchFromCache from '@/utilities/fetchFromCache';
import { Module, VuexModule, MutationAction } from 'vuex-module-decorators';
let MulticlassImprovements = class MulticlassImprovements extends VuexModule {
    constructor() {
        super(...arguments);
        this.multiclassImprovements = [];
        this.cachedVersion = 0;
    }
    async fetchMulticlassImprovements() {
        const { data: multiclassImprovements, cachedVersion } = await fetchFromCache(this, 'multiclassImprovements', 'multiclassImprovement');
        return { multiclassImprovements, cachedVersion };
    }
};
__decorate([
    MutationAction({ mutate: ['multiclassImprovements', 'cachedVersion'] })
], MulticlassImprovements.prototype, "fetchMulticlassImprovements", null);
MulticlassImprovements = __decorate([
    Module({ namespaced: true, name: 'multiclassImprovements' })
], MulticlassImprovements);
export default MulticlassImprovements;
